import { Component, OnDestroy, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Subscription, Subject } from 'rxjs';
import { switchMap, debounceTime, distinctUntilChanged } from 'rxjs/operators';

import { environment } from 'src/environments/environment';

import { ProductBooking } from 'src/app/shared/product'
import { GlobalSettingsData } from 'src/app/shared/global-settings-data'
import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service'
import { ProductApiService } from 'src/app/services/product-api.service';

/**
 * Read-only table that displays active reservations (bookings) for a product.
 *
 * The pipeline inside `ngOnInit` subscribes to `listOptions$` (a `number` Subject carrying the
 * product ID) via debounced `distinctUntilChanged` + `switchMap(getProductBookingEx)`.  The call
 * uses `mainCompanyId`, `manDepartmentId`, and today's date from `GetglobalsettingsService`.
 *
 * On `prodId` input change the component pushes the new ID onto `listOptions$`.  An initial push
 * is fired in `ngOnInit` to populate the table immediately.
 */
@Component({
  selector: 'app-product-reservation-table',
  templateUrl: './product-reservation-table.component.html',
  styleUrls: ['./product-reservation-table.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ProductReservationTableComponent implements OnInit, OnDestroy, OnChanges {

  globalSettinsData: GlobalSettingsData;

  /** The product ID whose active reservations should be displayed. */
  @Input() prodId: number /*= 58644*/;

  /** Reservation rows returned by `getProductBookingEx`. */
  booking: ProductBooking[];
  selectedBooking: ProductBooking;

  private _productBookingQuery: Subscription;

  /** Internal Subject carrying product IDs to the debounced pipeline. */
  private listOptions$ = new Subject<number>();

  constructor(
    private prodApi: ProductApiService,
    private globalsettingsservice: GetglobalsettingsService,
  ) { }

  /** Reacts to `prodId` changes by pushing the new ID onto `listOptions$`. */
  ngOnChanges(changes: SimpleChanges) {
    //console.log('*** ProductListComponent ngOnChanges: enter');
    //environment.production || console.table(changes);
    for (let propName in changes) {
      let change = changes[propName];

      console.log('*** ProductReservationTableComponent ngOnChanges ' + propName + ' (actual): ' + JSON.stringify(change.currentValue));
      //console.log('*** ProductListComponent ngOnChanges ' + propName + ' (was):    ' + JSON.stringify(change.previousValue));

      switch (propName) {
        case 'prodId':
          this.listOptions$.next(change.currentValue);
          break;
      }
    }
  }

  /** Unsubscribes the booking HTTP subscription to prevent memory leaks. */
  ngOnDestroy(): void {
    console.log('*** ProductReservationTableComponent in ngOnDestroy')
    if (this._productBookingQuery) { this._productBookingQuery.unsubscribe(); }
  }

  /** Reads global settings, sets up the `listOptions$` → debounced `switchMap` pipeline, and fires an initial load. */
  ngOnInit(): void {
    console.log('*** ProductReservationTableComponent in ngOnInit')

    this.globalSettinsData = this.globalsettingsservice.getGlobalSettings();

    this._productBookingQuery =
      this.listOptions$.pipe(
        debounceTime(100),
        distinctUntilChanged(),
        switchMap((id: number) => {
          environment.production || console.log('*** ProductReservationTableComponent in switchMap: pgn=(' + id + ')');
          return this.prodApi.getProductBookingEx(id, this.globalSettinsData.mainCompanyId, this.globalSettinsData.manDepartmentId, new Date())
        })

      )
        .subscribe((data) => {
          //environment.production || console.log(data);
          this.booking = data;
        });
    this.listOptions$.next(this.prodId);
  }

}
